export default function formatSize(size) {
    let formattedSize = '';
    let units = '';

    if (size > 1024 * 1024 * 1024 * 1024) {
        formattedSize = (size / 1024 / 1024 / 1024 / 1024).toFixed(2);
        units = 'TB';
    } else if (size > 1024 * 1024 * 1024) {
        formattedSize = (size / 1024 / 1024 / 1024).toFixed(2);
        units = 'GB';
    } else if (size > 1024 * 1024) {
        formattedSize = (size / 1024 / 1024).toFixed(2);
        units = 'MB';
    } else if (size > 1024) {
        formattedSize = (size / 1024).toFixed(2);
        units = 'KB';
    } else {
        formattedSize = size.toString();
        units = 'B';
    }

    // eslint-disable-next-line prefer-template
    return formattedSize + ' ' + units;
}
